<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ gameName }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
            span(slot="value") {{ getModeName(parameters.mode) }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}
            span(slot="value") {{ difficult }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_actions') }}
            span(slot="value") {{ parameters.amountOfActions }}
        game-preview-setting(v-if="parameters.amountOfExamples")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_examples') }}
            span(slot="value") {{ parameters.amountOfExamples }}
        game-preview-setting(v-if="!parameters.withTime && parameters.timeLimit")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
            span(slot="value") {{ timeLimit }}
        game-preview-setting(v-if="(parameters.withSpeed || parameters.withTime) && parameters.speed")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_speed') }}
            span(slot="value") {{ parameters.speed }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
        game-preview-setting(v-if="parameters.withTime && parameters.isSpeedIncrease")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_acceleration') }}
            span(slot="value")
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_For') }}
                | {{ parameters.speedUp }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_After') }} {{ amountOfSpeedExercises }}
        game-preview-setting(v-if="parameters.isComplication")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_complication') }}
            span(slot="value")
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_For') }}
                | {{ amountOfActions }}
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_After') }} {{ amountOfComplicationExercises }}
        template(v-if="parameters.dictation")
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_dictation') }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}
                span(slot="value")
                    | {{ parameters.timeForAnswer }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
        game-preview-setting(v-if="parameters.jumpOver50 || parameters.jumpOver100")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_jumpOverPriority') }}
            span(slot="value") {{ jumpOver }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_answers') }}
            span(slot="value") {{ answers }}
        template(v-if="parameters.fractions")
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
                span(slot="value") {{ parameters.fractionalPart }}
        game-preview-setting(v-if="parameters.mirror")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_mirror') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
        game-preview-setting(v-if="parameters.roundNumbers")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_roundNumbers') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
        game-preview-setting(v-if="type === 'Anzan' && parameters.showExampleInTheLine")
            span(slot="name") {{ $i18n.t('trainer.trainer_gamePreview_exampleInTheLine') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
        template(v-if="parameters.extraOptions")
            game-preview-setting(v-if="parameters.extraOptions.music")
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_music') }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            game-preview-setting(v-if="parameters.extraOptions.pictures")
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_pictures') }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            game-preview-setting(v-if="parameters.extraOptions.x2")
                span(slot="name") X2
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            game-preview-setting(v-if="parameters.extraOptions.motion")
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_movement', {element: $i18n.t('trainer.trainer_gameFormSettingValue_numbers')}) }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
            game-preview-setting(v-if="parameters.extraOptions.voiceOver === undefined || parameters.extraOptions.voiceOver")
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_voiceActing') }}
                span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer'
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [TrainerUtilities, GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
        computed: {
            gameName() {
                return this.parameters.withTime
                    ? this.$i18n.t('common.common_gameName_anzanWithTime')
                    : this.$i18n.t('common.common_gameName_anzan');
            },
            amountOfComplicationExercises() {
                return this.parameters.tasksForComplication + ' '
                    + this.$i18n.tc('trainer.trainer_gamePreview_exampleDeclination', this.parameters.tasksForComplication);
            },
            amountOfSpeedExercises() {
                return this.parameters.tasksForSpeedUp + ' '
                    + this.$i18n.tc('trainer.trainer_gamePreview_exampleDeclination', this.parameters.tasksForSpeedUp);
            },
            amountOfActions() {
                return this.parameters.complication + ' '
                    + this.$i18n.tc('trainer.trainer_gamePreview_actionDeclination', this.parameters.complication);
            },
            timeLimit() {
                return this.parameters.timeLimit + ' '
                    + this.$i18n.tc('trainer.trainer_gamePreview_timeParamMinuteDeclination', this.parameters.timeLimit);
            },
            jumpOver() {
                if (this.parameters.jumpOver50 && this.parameters.jumpOver100) {
                    return '50, 100';
                }
                if (this.parameters.jumpOver50) {
                    return '50';
                }
                if (this.parameters.jumpOver100) {
                    return '100';
                }
            },
            answers() {
                if (this.parameters.positiveAnswers && this.parameters.negativeAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersAny');
                }
                if (this.parameters.positiveAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersOnlyPositive');
                }
                if (this.parameters.negativeAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersOnlyNegative');
                }
            },
            difficult() {
                return this.parameters.combining
                    ? this.getDifficultName(this.parameters.difficult) + ` (${this.$i18n.t('trainer.trainer_gameFormSetting_combining')})`
                    : this.getDifficultName(this.parameters.difficult);
            }
        }
    }
</script>
